import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import NewMembership from "./NewMembership";

class MembershipList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      searchParam: "",
      filter: {
        name: "",
        status: "active"
      },

      showAddMemebrship: false,
      showFilter: false,
      showDelete: false,

      selectedRow: null,

      isFilterActive: false,

      listPageSettings: {

        Title: "Membership",

        Search: {

          showSearch: true,
          placeholder: "Search by membrship name",

          onSearch: this.onSearch,

          onRefresh: this.onRefreshClick,

          onFilterClick: () =>
            this.setState({ showFilter: true }),

          isFilterActive: false
        },

        HeaderButtons: [

          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },

        ],

        Columns: [
          { Name: "Name", Type: "field", Columns: [{ Column: "Name" }] },
          {
            Name: "Description",
            Type: "field",
            Columns: [{ Column: "Description" }],
          },
          {
            Name: "Discount",
            Type: "field",
            Columns: [{ Column: "Discount" }],
          },
          {
            Name: "Validity",
            Type: "field",
            Columns: [{ Column: "Validity" }],
          },
          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "Name" },
              { Column: "Description" },
              { Column: "Discount", Label: "Discount" },
              { Column: "Validity", Label: "Validity" },
            ],
          },
        ],

        RowButtons: [

          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          },

          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete"
          }

        ]

      }

    };

  }

  componentDidMount() {
    this.loadData();
  }

  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const { page, pageSize, filter, searchParam } = this.state;

      const res =
        await this.props.getMembership(
          this.props.user.user.RegistrationID,
          (page - 1) * pageSize,     // from
          pageSize,                  // size
          filter.status || "active", // status
          searchParam || filter.name // search
        );

      let list = [];
      let totalCount = 0;

      if (res && res.hasOwnProperty("searchResult")) {
        list = res.searchResult;
      }

      if (res && res.hasOwnProperty("totalItemscount")) {
        totalCount = res.totalItemscount;
      }

      this.setState({
        list: list,
        totalCount: totalCount,
        loading: false
      });

    }

    catch (error) {

      console.error(error);

      this.setState({
        loading: false
      });

    }

  };

  // =====================
  // SEARCH
  // =====================

  onSearch = (text) => {

    this.setState({
      searchParam: text,
      page: 1
    },
      this.loadData
    );

  };

  onRefreshClick = () => {

    this.setState({

      filter: {
        name: "",
        status: "active"
      },

      searchParam: "",

      page: 1,

      isFilterActive: false

    },
      this.loadData
    );

  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount /
      this.state.pageSize
    );

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      },
        this.loadData
      );

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      },
        this.loadData
      );

    }

  };

  onFirstClick = () => {

    this.setState({
      page: 1
    },
      this.loadData
    );

  };

  onLastClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount /
      this.state.pageSize
    );

    this.setState({
      page: totalPages
    },
      this.loadData
    );

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({

      pageSize: Number(size),

      page: 1

    },
      this.loadData
    );

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({
        showAddMemebrship: true,
        selectedRow: null
      });

    }

    if (btn.Action === "options") {

      this.setState({
        showOption: true
      });

    }

  };

  // =====================
  // FILTER
  // =====================

  onApplyFilter = () => {

    this.setState({

      searchParam: this.state.filter.name,

      page: 1,

      showFilter: false,

      isFilterActive: true

    },
      this.loadData
    );

  };

  onClearFilter = () => {

    this.onRefreshClick();

    this.setState({
      showFilter: false
    });

  };

  // =====================
  // DELETE
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({

        showAddMemebrship: true,

        selectedRow: row

      });
    }

    if (btn.Type === "delete") {

      this.setState({

        showDelete: true,

        selectedRow: row

      });

    }

  };

  deleteRecord = async () => {
    this.setState({
       loading:true,
      showDelete:false
    },
    );

    await this.props.deleteMembership(
      this.state.selectedRow.key
    );


      // delay 3 seconds
  setTimeout(() => {
    this.setState(
      {
        loading: false,
        selectedRow: null
      },
      this.loadData
    );
  }, 3000);

   

  };

  // =====================
  // POPUP EVENTS
  // =====================

  onPostPopupSave = () => {

    this.setState({

      showAddMemebrship: false,

      selectedRow: null

    },
      this.loadData
    );

  };

  onClosePopup = () => {

    this.setState({

      showAddMemebrship: false,

      selectedRow: null

    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};
  render() {

    return (

      <>

        <ListingPage
          {...this.props}
           onPageChange={this.onPageChange}
          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,

              isFilterActive: this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() =>
              this.setState({
                showFilter: false
              })
            }

            onButtonClick={(action) => {

              if (action.toLowerCase() === "apply") {

                this.onApplyFilter();

              }

              else if (action.toLowerCase() === "clear") {

                this.onClearFilter();

              }

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }
            ]}
          >

            <Input
              type="text"
              label="Name"
              value={this.state.filter.name}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    name: v
                  }
                })
              }
            />

            <Input
              type="select"
              label="Status"
              value={this.state.filter.status}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    status: v
                  }
                })
              }
            >

              <option value="active">
                Active
              </option>

              <option value="inactive">
                Inactive
              </option>

              <option value="all">
                All
              </option>

            </Input>

          </Window>

        )}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();

              else
                this.setState({
                  showDelete: false
                });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }
            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

        {this.state.showAddMemebrship &&
          <NewMembership
            {...this.props}
            membership={this.state.selectedRow}
            onSave={() => this.onPostPopupSave()}
            onClose={() => this.onClosePopup()}
          />
        }

      </>

    );

  }

}

export default MembershipList;